import { FormControlledInput } from '@cocoonspace/ui/components/form-controlled-input'
import { Input } from '@cocoonspace/ui/components/input'
import { Textarea } from '@cocoonspace/ui/components/textarea'
import { useLingui } from '@lingui/react/macro'

import { useProfileFormContext } from '../use-profile-form.hook'
import { ImagePicker } from './image-picker'
import { SlugInput } from './slug-input'

const compactFieldClassNames = {
	formItem: 'pb-3',
	formMessage: 'relative',
}

export const ProfileGeneralFields = () => {
	const { t } = useLingui()
	const form = useProfileFormContext()

	return (
		<>
			<FormControlledInput
				label={t`Photo`}
				name='avatarUrl'
				classNames={compactFieldClassNames}
				render={({ field }) => (
					<ImagePicker
						outputSize={500}
						value={field.value}
						preview={form.watch('avatarPreview')}
						onChange={(value) => {
							field.onChange(value)
							if (!value) form.setValue('avatarPreview', '')
						}}
						onPreviewChange={(value) => {
							form.setValue('avatarPreview', value)
						}}
					/>
				)}
			/>

			<FormControlledInput
				label={t`Titre`}
				name='title'
				classNames={compactFieldClassNames}
				render={({ field }) => (
					<Input
						{...field}
						placeholder={t`Ex : John Doe Coach en tranformation`}
					/>
				)}
			/>

			<FormControlledInput
				label={t`Sous-titre`}
				name='subtitle'
				classNames={compactFieldClassNames}
				render={({ field }) => <Input {...field} />}
			/>

			<FormControlledInput
				label={t`Lien de la page`}
				name='slug'
				classNames={compactFieldClassNames}
				render={({ field }) => (
					<SlugInput value={field.value} onChange={field.onChange} />
				)}
			/>

			<FormControlledInput
				label={t`Description`}
				name='description'
				classNames={compactFieldClassNames}
				render={({ field }) => (
					<Textarea
						{...field}
						placeholder={t`Décrivez-vous en quelques mots...`}
						rows={4}
					/>
				)}
			/>
		</>
	)
}
